/** Works for US and the English-speakers of Canada */
export default function currencyFormatter(amount: number) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(amount);
}
